import React from "react";
import alert from "../../../assets/images/alert-circle.svg";

const ModalEventPublishedFailure = ({ handleClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-grey-25 bg-opacity-100">
      <div className="bg-white justify-center p-6 rounded-2xl shadow-lg max-w-md w-full">
        <div className="flex justify-center space-x-4">
          <img src={alert} alt="alert" className="size-20" />
        </div>
        <h2 className="justify-center text-center text-lg font-semibold mt-4 mb-6 text-grey-900">
          There was an error publishing your event
        </h2>
        <p className="mb-6 text-sm text-grey-600 text-center">
          {`Keep editing, or save as a draft to work on it later`}
        </p>
        <div className="flex justify-center space-x-4">
          <button
            className="bg-grey-25 hover:bg-grey-50 text-grey-900 font-semibold px-4 py-3 text-base rounded-lg border-2 "
            onClick={() => handleClose()}
          >
            Stay on event page
          </button>
          <button
            className=" bg-grey-700 hover:bg-grey-800  text-grey-25 px-4 py-3 text-base font-semibold rounded-lg"
            onClick={() => {
              handleClose();
            }}
          >
            Stay on event page
          </button>
        </div>
      </div>
    </div>
  );
};
export default ModalEventPublishedFailure;
